module.exports = __webpack_public_path__ + "static/media/green-card-front-example.ecdd0ff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/green-card-front-example.png
// module id = 845
// module chunks = 0